import React from 'react';
import Reveal from './Reveal';

/**
 * Wrap each child in a `Reveal` with an incrementing delay, so a list or grid
 * cascades in instead of appearing as one block.
 *
 * `cap` stops the delay growing without bound — past that many items the
 * stagger resets, which keeps a 34-tile grid from taking three seconds to
 * finish while still reading as a cascade.
 *
 * @param {object} props
 * @param {number} props.step  ms between successive children
 * @param {number} props.cap   items before the delay wraps back to zero
 */
export function Stagger({
  children,
  as: Tag = 'div',
  step = 70,
  cap = 8,
  start = 0,
  variant = 'up',
  distance,
  duration,
  childClassName,
  className,
  ...rest
}) {
  const items = React.Children.toArray(children);

  return (
    <Tag className={className} {...rest}>
      {items.map((child, i) => (
        <Reveal
          key={child.key ?? i}
          variant={variant}
          distance={distance}
          duration={duration}
          delay={start + (i % cap) * step}
          className={childClassName}
        >
          {child}
        </Reveal>
      ))}
    </Tag>
  );
}

export default Stagger;
